import React, { Component } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import Creatable from "react-select/lib/Creatable";
import DatePicker from "react-datepicker";
import { connect } from "react-redux";
import moment from "moment";
import { buildOptions } from "../utils";
import { uniq } from "lodash";
import withFetchHook from "../withFetchHook";
import { sendStaffAppMetaData } from "../staffApp/eventTriggers";

class SoberLivingFormModal extends Component {
  handleClose() {
    this.props.closeModal();
  }

  handleChange(name, value) {
    this.props.updateField(name, value);
  }

  updateResidentSoberLivings(soberLiving) {
    const { organizationName, resident } = this.props;

    return this.props.fetch(`/organizations/${organizationName}/residents/${resident.id}.json`, {
      method: "PATCH",
      headers: {'Content-Type': 'application/json'},
      data: JSON.stringify({
        resident: {
          sober_livings_attributes: [soberLiving]
        }
      })
    });
  }

  deleteSoberLiving() {
    const { soberLiving, deleteSoberLiving, closeModal, isStaffApp } = this.props;

    this.updateResidentSoberLivings({
      id: soberLiving.id,
      _destroy: true
    }).then(() => {
      deleteSoberLiving(soberLiving);
      if (isStaffApp) {
        alert("Sober living deleted successfully.")
        this.setDefaultStaffAppMetaData()
      }
      closeModal();
    });
  }

  saveSoberLiving() {
    const { soberLiving, updateSoberLivings, closeModal, isStaffApp } = this.props;

    this.updateResidentSoberLivings(soberLiving).then((data) => {
      updateSoberLivings(data.sober_livings);
      if (isStaffApp) {
        alert("Changes to sober living saved successfully.")
        this.setDefaultStaffAppMetaData()
      }
      closeModal();
    });
  }

  setDefaultStaffAppMetaData = () => sendStaffAppMetaData(this.props.tabDefaultMetaData)

  saveSoberLivingFunction = (e) => {
    this.props.dispatch(this.saveSoberLiving())
  }

  componentDidMount() {
    document.addEventListener('saveSoberLiving', this.saveSoberLivingFunction)
  }

  componentWillUnmount() {
    document.removeEventListener('saveSoberLiving', this.saveSoberLivingFunction)
  }

  render() {
    const {
      name,
      street_address,
      city,
      state,
      zip_code,
      admitted_at,
      discharged_at,
      reason_for_discharge,
      notes
    } = this.props.soberLiving;
    const reasonForDischargeOptions = buildOptions(uniq([
      "Financial", "At Staff Request", "Relapsed", "Normal Transition", reason_for_discharge
    ]));
    const reasonForDischargeValue = reasonForDischargeOptions.find((option) => option.value === reason_for_discharge);
    const { isStaffApp, hasDelete, hasEdit } = this.props
    return (
      <Modal show={this.props.show} onHide={this.handleClose.bind(this)}>
        {
          !isStaffApp &&
          <Modal.Header closeButton>
            <Modal.Title>SoberLiving</Modal.Title>
          </Modal.Header>
        }
        <Modal.Body className={hasEdit ? "" : "form-modal-width"}>
          {hasEdit ? (
            <>
              <Form.Group controlId="soberLivingName">
                <Form.Label>Facility Name</Form.Label>
                <Form.Control
                  value={name}
                  onChange={(e) => this.handleChange('name', e.target.value)} />
              </Form.Group>
              <Form.Group controlId="soberLivingStreetAddress">
                <Form.Label>Street Address</Form.Label>
                <Form.Control
                  value={street_address}
                  onChange={(e) => this.handleChange('street_address', e.target.value)} />
              </Form.Group>
              <Form.Group controlId="soberLivingCity">
                <Form.Label>City</Form.Label>
                <Form.Control
                  value={city}
                  onChange={(e) => this.handleChange('city', e.target.value)} />
              </Form.Group>
              <Form.Group controlId="soberLivingState">
                <Form.Label>State</Form.Label>
                <Form.Control
                  value={state}
                  onChange={(e) => this.handleChange('state', e.target.value)} />
              </Form.Group>
              <Form.Group controlId="soberLivingZipCode">
                <Form.Label>Zip</Form.Label>
                <Form.Control
                  value={zip_code}
                  onChange={(e) => this.handleChange('zip_code', e.target.value)} />
              </Form.Group>
              <Row>
                <Col sm={6}>
                  <Form.Group controlId="treatmentCenterAdmittedAt">
                    <Form.Label>Admitted At</Form.Label>
                    <DatePicker
                      className="form-control"
                      selected={admitted_at ? moment(admitted_at) : null}
                      onChange={(date) => {
                        this.handleChange(
                          'admitted_at',
                          date ? date.format("YYYY-MM-DD") : null
                        );
                      }} />
                  </Form.Group>
                </Col>
                <Col sm={6}>
                  <Form.Group controlId="treatmentCenterDischargedAt">
                    <Form.Label>Discharged At</Form.Label>
                    <DatePicker
                      className="form-control"
                      selected={discharged_at ? moment(discharged_at) : null}
                      onChange={(date) => {
                        this.handleChange(
                          'discharged_at',
                          date ? date.format("YYYY-MM-DD") : null
                        );
                      }} />
                  </Form.Group>
                </Col>
              </Row>
              <Form.Group controlId="soberLivingReasonForDischarge">
                <Form.Label>Reason For Discharge</Form.Label>
                <Creatable
                  options={reasonForDischargeOptions}
                  value={reasonForDischargeValue}
                  onChange={(option) => {
                    this.handleChange("reason_for_discharge", option.value)
                  }} />
              </Form.Group>
              <Form.Group controlId="soberLivingNotes">
                <Form.Label>Notes</Form.Label>
                <Form.Control
                  as="textarea"
                  value={notes}
                  onChange={(e) => this.handleChange('notes', e.target.value)} />
              </Form.Group>
            </>
          ) : (
            <>
              <Form.Group>
                <Form.Label>Facility Name</Form.Label>
                <div className="form-control-plaintext">{name || 'N/A'}</div>
              </Form.Group>
              <Form.Group>
                <Form.Label>Street Address</Form.Label>
                <div className="form-control-plaintext">{street_address || 'N/A'}</div>
              </Form.Group>
              <Form.Group>
                <Form.Label>City</Form.Label>
                <div className="form-control-plaintext">{city || 'N/A'}</div>
              </Form.Group>
              <Form.Group>
                <Form.Label>State</Form.Label>
                <div className="form-control-plaintext">{state || 'N/A'}</div>
              </Form.Group>
              <Form.Group>
                <Form.Label>Zip</Form.Label>
                <div className="form-control-plaintext">{zip_code || 'N/A'}</div>
              </Form.Group>
              <Row>
                <Col sm={6}>
                  <Form.Group>
                    <Form.Label>Admitted At</Form.Label>
                    <div className="form-control-plaintext">{admitted_at ? moment(admitted_at).format('MM/DD/YYYY') : 'N/A'}</div>
                  </Form.Group>
                </Col>
                <Col sm={6}>
                  <Form.Group>
                    <Form.Label>Discharged At</Form.Label>
                    <div className="form-control-plaintext">{discharged_at ? moment(discharged_at).format('MM/DD/YYYY') : 'N/A'}</div>
                  </Form.Group>
                </Col>
              </Row>
              <Form.Group>
                <Form.Label>Reason For Discharge</Form.Label>
                <div className="form-control-plaintext">{reason_for_discharge || 'N/A'}</div>
              </Form.Group>
              <Form.Group>
                <Form.Label>Notes</Form.Label>
                <div className="form-control-plaintext">{notes || 'N/A'}</div>
              </Form.Group>
            </>
          )}
        </Modal.Body>
        {
          !isStaffApp ?
          <Modal.Footer>
            {
              this.props.action === "edit" && hasDelete &&
              <Button
                variant="outline-danger"
                onClick={() => {
                  const { soberLiving } = this.props;
                  this.deleteSoberLiving(soberLiving);
                }}>
                Delete
              </Button>
            }
            <Button
              variant="info"
              onClick={() => this.saveSoberLiving()}>
              {this.props.action === "edit" ? "Update" : "Create"}
            </Button>
          </Modal.Footer> :
          <>
            {
              this.props.action == 'edit' && hasDelete &&
              <div className="p-4">
                <Button
                variant="outline-danger w-100"
                onClick={() => {
                  const { soberLiving } = this.props;
                  this.deleteSoberLiving(soberLiving);
                }}>
                  Delete
                </Button>
              </div>
            }
          </>
        }
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    show: state.ui.soberLivingModal.show,
    soberLiving: state.ui.soberLivingModal.soberLiving,
    action: state.ui.soberLivingModal.action,
    organizationName: state.organization.name,
    resident: state.resident,
    config: state.config,
    isStaffApp: state.config.isStaffApp,
    resident_tabs: state.config.resident_tabs,
    tabDefaultMetaData: state.config.tab_default_meta_data.find(tab=> tab.detail == 'sober_living_history'),
    hasDelete: state.current_user.permissions.includes('Delete'),
    hasEdit: state.current_user.permissions.includes('Edit')
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    closeModal: () => {
      dispatch({
        type: "CLOSE_RESOURCE_MODAL",
        payload: { resourceName: "soberLiving" }
      });
    },
    updateField: (name, value) => {
      dispatch({
        type: "UPDATE_RESOURCE_FIELD",
        payload: { resourceName: "soberLiving", name, value }
      });
    },
    updateSoberLivings: (soberLivings) => {
      dispatch({
        type: "UPDATE_SOBER_LIVINGS",
        payload: { soberLivings }
      });
    },
    createSoberLiving: (soberLiving) => {
      dispatch({
        type: "CREATE_SOBER_LIVING",
        payload: { soberLiving }
      });
    },
    deleteSoberLiving: (soberLiving) => {
      dispatch({
        type: "DELETE_SOBER_LIVING",
        payload: { soberLiving }
      })
    },
    dispatch: (func) => dispatch(func()),
  };
}

export default withFetchHook(connect(mapStateToProps, mapDispatchToProps)(SoberLivingFormModal));
